<div class='surface-ground px-3 py-5 md:px-3 lg:px-4'>
  <div class='text-900 font-medium text-xl mb-3'>{{ 'my_account' | translate }}</div>
  <p class='m-0 mb-4 p-0 text-600 line-height-3 mr-3'>
    {{ 'user_account_hint' | translate }}
  </p>
  <div class='surface-card p-4 shadow-2 border-round'>
    @if ($user | async; as user) {
      <div class='surface-section px-6 py-5'>
        <div class='flex align-items-start flex-column lg:flex-row lg:justify-content-between'>
          <div class='flex align-items-start flex-column md:flex-row'>
            <img
              src='https://static.vecteezy.com/system/resources/previews/009/292/244/non_2x/default-avatar-icon-of-social-media-user-vector.jpg'
              class='mr-5 mb-3 lg:mb-0 border-circle'
              style='width: 90px; height: 90px;' alt='user-avatar'>
            <div><span class='text-900 font-medium text-3xl'>{{ user.firstName }} {{ user.lastName }}</span>
              <div class='flex align-items-center flex-wrap text-sm'>
                <div class='mr-5 mt-3'><span class='font-medium text-500'>{{ 'username' | translate }}</span>
                  <div class='text-700 mt-2'>{{ user.username }}</div>
                </div>
                <div class='mr-5 mt-3'><span class='font-medium text-500'>{{ 'e_mail' | translate }}</span>
                  <div class='text-700 mt-2'>{{ user.email }}</div>
                </div>
                <div class='mr-5 mt-3'><span class='font-medium text-500'>{{ 'e_mail_verified' | translate }}</span>
                  <div class='text-700 mt-2'>
                    <i [class]="user.emailVerified ? 'pi pi-verified' : 'pi pi-ban'"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='mt-3 lg:mt-0'>
            <button pButton pRipple (click)='changePassword()' [rounded]='true' size='small' class='mr-2'
                    [label]="'update_password' | translate"
                    icon='pi pi-key'></button>
          </div>
        </div>

        <div class='mr-5 mt-3'>
          <span class='font-medium text-500'>{{ 'user_roles' | translate }}</span>
          <div class='max-w-30rem	flex flex-wrap gap-2 mt-2'>
            @for (role of userRoles; track role) {
              <p-tag [value]='role' [rounded]='true' severity='secondary' class='opacity-70' />
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
